import { DefaultState } from 'features/types';
import { ResourceEventRsvpStatuses } from 'features/resources/types';

export type ResourceDetailsState = DefaultState & {
  data: {
    details: ResourceDetails | null;
  }
};

export type ResourceCommentAuthor = {
  name: string;
  email: string;
  photo?: string;
}

export type ResourceCommentResponse = {
  postComments: ResourceCommentRow[];
}

export type ResourceCommentRow = {
  id: string;
  postId: string;
  parentId: string | null;
  authorId: string;
  description: string;
  author?: ResourceCommentAuthor;
  children: ResourceCommentRow[];
  createdAt: Date;
  edited: boolean;
  isOwnComment?: boolean;
}

export type ResourceDetails = {
  id: string;
  title: string;
  description: string;
  authorLogo?: string;
  coverImage?: string;
  organizationName: string;
  jobSeekerName: string;
  jobSeekerId?: string;
  filePath?: string;
  fileExists: boolean;
  postType: string;
  isOwnPost: boolean;
  postLikes?: string[];
  postLiked: boolean;
  allowedToLike: boolean;
  allowedToComment: boolean;
  commentsAllowed: boolean;
  commentCount?: number;
  postComments?: ResourceCommentRow[];
  postCommented: boolean;
  fromDate?: string;
  toDate?: string;
  fromTime?: string;
  toTime?: string;
  withEndDate?: boolean;
  timezone?: string;
  timezoneAbbreviation: string;
  eventFormat?: string;
  eventFormatForDisplay?: string;
  eventPersonAddress?: string;
  eventLink?: string;
  jobSeekerEventRsvp: ResourceEventRsvpStatuses;
  jobSeekerEventRsvpForDisplay: ResourceEventRsvpStatuses;
  eventAreGoingRsvpsCount: number;
  createdAt: Date;
  offeredBy?: string;
  offeredByOrganizationName?: string;
  organizationWebsite?: string;
  groupName?: string;
  displayName?: string;
  contactInfo?: string;
  specialties?: string[];
  serviceDeliveryMethods?: string[];
  serviceArea?: string;
  compensation?: string;
  ratePricing?: string;
  availability?: string;
  productLocationType?: string;
  productLocation?: string;
  productUrl?: string;
  costType?: string;
  priceDetails?: string;
};

export enum GetResourceDetailsTypes {
  Discover = 'Discover',
  Community = 'Community',
  JobSeeker = 'JobSeeker',
}
